import { redirect } from "@tanstack/react-router";
import { Fragment } from "react/jsx-runtime";

import { OnboardingLayout } from "@/components/layouts/onboarding-layout";
import { OrganizationLayout } from "@/components/layouts/organization-layout";
import { ActiveOrganizationProvider } from "@/context/active-organization-provider";
import { CurrentUserProvider, useCurrentUser } from "@/context/current-user-provider";
import { SearchProvider } from "@/context/search-provider";
import { CheckInUpdates } from "@/features/check-in/components/check-in-updates";
import { GuardMeUpdatesSubscription } from "@/features/guardme/components/guardme-updates-subscription";
import { IncidentsUpdates } from "@/features/incidents/components/incidents-updates";
import { OrganizationUpdates } from "@/features/settings/subscriptions/OrganizationUpdates";

function LayoutSelector() {
  const {
    currentUser: { memberships },
  } = useCurrentUser();

  if (memberships.length === 0) {
    return <OnboardingLayout />;
  }

  return (
    <ActiveOrganizationProvider>
      {memberships.map((item) => (
        <Fragment key={item.id}>
          <OrganizationUpdates organizationId={item.id} />
          <GuardMeUpdatesSubscription organizationId={item.id} />
          <IncidentsUpdates organizationId={item.id} />
          <CheckInUpdates organizationId={item.id} />
        </Fragment>
      ))}
      <SearchProvider>
        <OrganizationLayout />
      </SearchProvider>
    </ActiveOrganizationProvider>
  );
}

export const Route = createFileRoute({
  beforeLoad: ({ context, location }) => {
    // If Auth0 reports the user isn't logged in, redirect them
    if (!context.auth?.isAuthenticated) {
      throw redirect({
        to: "/sign-in",
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: () => (
    <CurrentUserProvider>
      <LayoutSelector />
    </CurrentUserProvider>
  ),
});
